import React, { useEffect, useState } from "react";

import { Button } from "antd";

import { getActiveBrand } from "../../../apis/BrandContentApi";

import BannerManagement from "./BannerManagement";
import StoryManagement from "./StoryManagement";
import "./brandStyle.scss";

export default function HomeContentPage() {
  const [activeBrands, setActiveBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);

  /**
   * 활성 브랜드 조회
   */
  useEffect(() => {
    const fetchActiveBrand = async () => {
      try {
        const response = await getActiveBrand();
        setActiveBrands(response ?? []);
        setSelectedBrand(response[0] ?? null);
      } catch (error) {
        console.error("Error fetching active brand:", error);
        setActiveBrands([]);
        return;
      }
    };
    fetchActiveBrand();
  }, []);

  return (
    <>
      <div className="home-content-page-button-wrap">
        <h1 style={{ fontSize: "20px", fontWeight: "bold" }}>홈 콘텐츠 관리</h1>
      </div>
      <div className="home-content-page">
        {/* 홈 브랜드 선택 섹션 */}
        <div className="home-brand-list banner-section">
          <h2
            className="banner-section__header-title"
            style={{ marginBottom: "16px" }}
          >
            🏠 브랜드 선택
          </h2>
          <div className="home-brand-list-button-wrap">
            {activeBrands.map((brand) => (
              <Button
                type="default"
                key={brand.id}
                onClick={() => setSelectedBrand(brand)}
                className={selectedBrand?.id === brand.id && "active"}
              >
                {brand.brand_name}
              </Button>
            ))}
          </div>
        </div>

        {/* 배너 관리 컴포넌트 */}
        <BannerManagement
          selectedBrand={selectedBrand}
          contentType="HOME_MAIN_BANNER"
          showMobile={true}
        />

        {/* 스토리 관리 컴포넌트 */}
        <StoryManagement
          selectedBrand={selectedBrand}
          contentType="HOME_MAIN_STORY"
          title="홈 브랜드 스토리"
          size="586 * 320 (157:86)"
        />
      </div>
    </>
  );
}
